var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50993 0.620078C9.88993 0.400078 10.3699 0.400078 10.7499 0.620078L17.4599 4.4501L17.6299 4.52007V4.56008L19.4999 5.63009C19.9899 5.91009 20.2299 6.49009 20.0899 7.04009C19.9499 7.59009 19.4499 7.97008 18.8799 7.97008H1.37992C0.809924 7.97008 0.319963 7.58009 0.169963 7.04009C0.0199634 6.50009 0.269929 5.92009 0.759929 5.63009L2.62992 4.56008V4.52007L2.79997 4.46007L9.50993 0.620078ZM2.62992 9.21007H5.12992V16.7101H6.68986V9.21007H9.18986V16.7101H11.06V9.21007H13.56V16.7101H15.1199V9.21007H17.6199V16.8801C17.6199 16.8801 17.6699 16.9101 17.6899 16.9201L19.56 18.1701C20.02 18.4701 20.22 19.0401 20.06 19.5701C19.9 20.1001 19.4099 20.4601 18.8599 20.4601H1.3599C0.809905 20.4601 0.319954 20.1001 0.159954 19.5701C-4.63314e-05 19.0401 0.199954 18.4701 0.659954 18.1701L2.52995 16.9201C2.52995 16.9201 2.5799 16.8901 2.5999 16.8801V9.21007H2.62992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankW);
export default __webpack_public_path__ + "static/media/bank_w.7760754ad659627c0840c4a37c934ef2.svg";
export { ForwardRef as ReactComponent };